import React from 'react';
import {
  Box, Button, Paper, Typography
} from '@mui/material';

const BottomBar = ({
  activeStep,
  selectedItems,
  selectedElements,
  mandatoryItems,
  onNext,
  onBack,
  pubDateIncomplete
}) => {
  const mandatoryItemIds = mandatoryItems.map(item => item.id);
  const allMandatorySelected = mandatoryItemIds.every(id => {
    if (id === 'pubdate') {
      return (selectedElements[id] && selectedElements[id].trim()) || pubDateIncomplete;
    }
    return selectedElements[id] && selectedElements[id].trim();
  });
  const canProceed = allMandatorySelected;

  return (
    <Paper
      elevation={0}
      sx={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 1000,
        p: 2,
        bgcolor: 'white',
        borderTop: '1px solid #e0e0e0',
        boxShadow: '0 -4px 12px rgba(0, 0, 0, 0.1), 0 -2px 6px rgba(0, 0, 0, 0.06)'
      }}
    >
      <Box display="flex" justifyContent="center" gap={2}>
        <Button
          variant="outlined"
          onClick={onBack}
          disabled={activeStep === 0}
          sx={{
            borderRadius: 2,
            fontWeight: 600,
            textTransform: 'none',
            minWidth: 120
          }}
        >
          Back
        </Button>
        <Button
          variant="contained"
          onClick={onNext}
          disabled={!canProceed || activeStep === 1}
          sx={{
            borderRadius: 2,
            fontWeight: 600,
            textTransform: 'none',
            minWidth: 120,
            bgcolor: '#1677ff',
            '&:hover': { bgcolor: '#156de0' }
          }}
        >
          Next
        </Button>
      </Box>
    </Paper>
  );
};

export default BottomBar; 